import { useLinkTo } from '@react-navigation/native';
import Constants from 'expo-constants';
import { ImageBackground } from 'expo-image';
import {
  Dimensions,
  Image as RNImage,
  Text as RNText,
  StyleSheet,
  View,
  useWindowDimensions,
} from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import backgroundImageDesktop from 'assets/error-background-desktop.png';
import backgroundImageMobile from 'assets/error-background-mobile.png';
import NoCopyrightImage from 'assets/no-copyright.png';

import Button from 'components/Button';

export const NoCopyright: React.FC = () => {
  const linkTo = useLinkTo();
  const { width } = useWindowDimensions();
  const isMobile = width < 950;
  const backgroundImage = isMobile ? backgroundImageMobile : backgroundImageDesktop;

  const title = (
    <RNText
      style={[
        styles.title,
        {
          fontSize: calcSizeForDevice(32, 41),
          lineHeight: calcSizeForDevice(36, 41),
          marginBottom: calcSizeForDevice(24, 60),
        },
      ]}>
      Ixe! Tarde demais...
    </RNText>
  );

  const description = (
    <RNText
      style={[
        styles.description,
        {
          fontSize: calcSizeForDevice(18, 27),
          lineHeight: calcSizeForDevice(22, 27),
          textAlign: isMobile ? 'center' : 'left',
          marginBottom: calcSizeForDevice(24, 60),
        },
      ]}>
      Este conteúdo foi removido devido a questãode direitos ou parcerias. Que tal explorar outras
      opções do catálogo?
    </RNText>
  );

  const image = (
    <RNImage
      source={NoCopyrightImage}
      style={[styles.image, { marginBottom: calcSizeForDevice(24, 60) }]}
      resizeMode="contain"
    />
  );

  const action = (
    <Button
      useTVFocus
      hasTVPreferredFocus
      variant="gradient"
      size="md"
      onPress={() => linkTo('/')}
      style={{
        height: calcSizeForDevice(40, 60),
        paddingHorizontal: calcSizeForDevice(20, 30),
      }}
      textStyle={{ fontSize: calcSizeForDevice(16, 24) }}>
      Voltar para a página inicial
    </Button>
  );

  if (!isMobile) {
    return (
      <ImageBackground
        source={backgroundImage}
        style={{
          padding: isMobile ? 24 : 44,
          paddingTop: isMobile ? Constants?.statusBarHeight : 0,
          flex: 1,
          justifyContent: isMobile ? 'flex-start' : 'center',
          maxHeight: Dimensions.get('screen').height,
          overflow: 'hidden',
        }}>
        <View style={[styles.desktopContainer, { padding: calcSizeForDevice(16) }]}>
          <View
            style={[
              styles.desktopContentContainer,
              {
                maxWidth: calcSizeForDevice(450),
                padding: calcSizeForDevice(16),
                paddingHorizontal: calcSizeForDevice(16),
                marginRight: calcSizeForDevice(24, 32),
              },
            ]}>
            {title}
            {description}
            {action}
          </View>

          {image}
        </View>
      </ImageBackground>
    );
  }

  return (
    <ImageBackground
      source={backgroundImage}
      style={{
        padding: isMobile ? 24 : 44,
        paddingTop: isMobile ? Constants?.statusBarHeight : 0,
        flex: 1,
        justifyContent: isMobile ? 'flex-start' : 'center',
        maxHeight: Dimensions.get('screen').height,
        overflow: 'hidden',
      }}>
      <View style={[styles.mobileContainer, { padding: calcSizeForDevice(16) }]}>
        <View
          style={[
            styles.mobileContentContainer,
            { padding: calcSizeForDevice(16), paddingHorizontal: calcSizeForDevice(16) },
          ]}>
          {title}
          {image}
          {description}
          {action}
        </View>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  title: {
    fontWeight: 'bold',
    color: 'white',
  },
  description: {
    color: 'white',
  },
  image: {
    width: 400,
    height: 400,
    maxHeight: 400,
  },
  desktopContainer: {
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  desktopContentContainer: {},
  mobileContainer: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileContentContainer: {
    alignItems: 'center',
  },
});
